import { Button } from '../../components/Button';
import { useI18n } from '../../i18n/i18n-context';
import { useAccount } from './account-context';
import { AccountMenu } from './AccountMenu';
import { UsageChip } from './UsageChip';
import './account.css';

/** The header's usage, upgrade or billing, sign-in, and account controls. */
export function AccountBar() {
  const { t } = useI18n();
  const { account, openDialog } = useAccount();
  if (!account) return null;
  const { user, plan } = account;

  return (
    <div className="account-bar">
      <UsageChip account={account} opensBreakdown />
      {plan === 'free' ? (
        <Button
          variant="primary"
          icon="sparkle"
          className="bar-button"
          onClick={() => {
            openDialog('plans', 'upgrade');
          }}
        >
          {t.account.upgrade}
        </Button>
      ) : (
        <Button
          className="bar-button"
          icon="card"
          aria-label={t.common.manageBilling}
          onClick={() => {
            openDialog('billing');
          }}
        >
          <span className="bar-billing-label" aria-hidden="true">
            {t.common.manageBilling}
          </span>
          <span className="bar-billing-label--compact" aria-hidden="true">
            {t.account.billing}
          </span>
        </Button>
      )}
      <div className="account-bar-identity">
        {!user && (
          <Button
            className="bar-button bar-button--secondary"
            icon="sign-in"
            onClick={() => {
              openDialog('sign-in');
            }}
          >
            {t.common.signIn}
          </Button>
        )}
        <AccountMenu account={account} />
      </div>
    </div>
  );
}
